import { runtime } from './runtime.js';
export default {
    rpc: {},
    runtime,
    types: {
        TAssetConversion: 'Option<MultiLocation>'
    }
};
